import {
	Button,
	Typography,
} from '@mui/material'
import type {
	JSX,
} from 'react'
import {
	memo,
} from 'react'

import {
	HStack,
	VStack,
} from '@/shared/components/stack'
import {
	AppRouterKeys,
} from '@/shared/model/constants'

import {
	ErrorFallbackCode,
	ErrorFallbackRoot,
} from './error-fallback.styles'

export const ErrorFallback = memo((): JSX.Element => {
	const handleReload = (): void => {
		window.location.reload()
	}

	const handleHome = (): void => {
		window.location.href = AppRouterKeys.HOME
	}

	return (
		<ErrorFallbackRoot>
			<VStack spacing={1} alignItems='center'>
				<ErrorFallbackCode>ERROR</ErrorFallbackCode>
				<Typography color='on-surface' variant='body-medium'>
					Что-то пошло не так
				</Typography>
				<Typography color='hint' variant='body-xs-small'>
					Произошла непредвиденная ошибка. Попробуйте перезагрузить страницу.
				</Typography>
			</VStack>

			<HStack spacing={2}>
				<Button
					size='small'
					color='error'
					variant='primary'
					onClick={handleReload}
				>
					Перезагрузить
				</Button>

				<Button
					size='small'
					color='neutral'
					variant='outlined'
					onClick={handleHome}
				>
					На главную
				</Button>
			</HStack>
		</ErrorFallbackRoot>
	)
})

ErrorFallback.displayName = 'ErrorFallback'
